import { useCallback, useState } from 'react';

const STORAGE_PREFIX = 'ei-cart-tracking.filters-expanded.';

function isCompactViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 767px)').matches;
}

function readStored(storageKey: string): boolean | null {
  if (typeof window === 'undefined') return null;
  try {
    const stored = window.localStorage.getItem(`${STORAGE_PREFIX}${storageKey}`);
    if (stored === null) return null;
    return stored !== 'false';
  } catch {
    return null;
  }
}

function writeStored(storageKey: string, expanded: boolean) {
  try {
    window.localStorage.setItem(`${STORAGE_PREFIX}${storageKey}`, String(expanded));
  } catch {
    /* ignore quota / privacy errors */
  }
}

/**
 * Estado de expandir/retrair filtros.
 * Mobile: inicia fechado (ignora localStorage).
 * Desktop: aberto por padrão; respeita localStorage se existir.
 */
export function useFiltersPanelExpanded(storageKey: string) {
  const [expanded, setExpanded] = useState(() => {
    if (isCompactViewport()) return false;
    const stored = readStored(storageKey);
    return stored === null ? true : stored;
  });

  const toggle = useCallback(() => {
    setExpanded((current) => {
      const next = !current;
      writeStored(storageKey, next);
      return next;
    });
  }, [storageKey]);

  return { expanded, toggle };
}
